module.exports = __webpack_public_path__ + "static/iso_16.d5029ae4.png";